import { withChildren } from '@builder.io/react';
import { createBuilderModule } from '../../builder';
import { Card } from './Card';
import { BACKGROUND_COLOR_KEYS } from '../../constants';

export default createBuilderModule(withChildren(Card), {
  name: 'Card',
  image: 'https://cdn.zappy.app/d87fedcef4c62762a559c5dd83614817.png',
  inputs: [
    { name: 'heading', type: 'string' },
    { name: 'subHeading', type: 'string' },
    { name: 'description', type: 'richText' },
    {
      name: 'backgroundColor',
      type: 'string',
      enum: BACKGROUND_COLOR_KEYS,
    },
  ],
});
